export default "__VITE_ASSET__62f43a35__"